/**
 * Copyright 2023-2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { When } from "react-if";
import { v4 } from "uuid";
import { Spacer, Text, theme } from "@nordcloud/gnui";
import { EventActionResourceReportResult } from "~/generated/graphql";
import { getTitleText, isNotEmpty } from "~/tools";

type Props = { result: EventActionResourceReportResult };

export function ResourceDetails({ result }: Props) {
  const {
    __typename: IgnoredTypename,
    outputUri: IgnoredOutputUri,
    output: IgnoredOutput,
    ...packageStatuses
  } = result;
  const prepareResult = Object.keys(packageStatuses).map(
    (packageStatus, index) => {
      return {
        id: v4(),
        label: packageStatus,
        data: Object.values(packageStatuses)[index] ?? [],
      };
    }
  );

  return (
    <>
      {prepareResult.map((item) => {
        return (
          <div key={item.id}>
            <When condition={isNotEmpty(item.data)}>
              <Text weight="bold" mb={theme.spacing.spacing02}>
                {`${getTitleText(item.label)}:`}
              </Text>
              {item.data?.map((i, idx) => (
                <Text
                  mb={theme.spacing.spacing01}
                  key={`${i.name}-${i.id}-${idx}`}
                >
                  {i.name} {`(${i.id})`}
                  {i.previousVersion ? (
                    <>{` [${i.previousVersion}]`} &rarr;</>
                  ) : (
                    ""
                  )}
                  {i.version ? ` [${i.version}]` : ""}
                </Text>
              ))}
              <Spacer height={theme.spacing.spacing01} />
            </When>
          </div>
        );
      })}
    </>
  );
}
